/**
 * Which climate products this app is built on, and when they were checked.
 *
 * Same purpose as `financeDefaults.ts`: a vintage that has gone stale should be
 * visible on screen rather than buried in a pipeline. Unlike the finance
 * constants, none of these are editable — they are facts about the data, not
 * assumptions the user can override.
 */

export const AS_OF = "August 2026";

/**
 * The model behind every projected figure.
 *
 * ALADIN-Climat is the CNRM regional model that DRIAS itself is built on, and
 * these indices are published openly on data.gouv — which is why this pipeline
 * needs no account and no manual download. What they do not carry is the TRACC
 * framing: the government's adaptation trajectory is expressed as warming
 * levels (+2.0 / +2.7 / +4.0 °C) rather than as RCP pathways. Roughly, RCP 4.5
 * at mid-century and RCP 8.5 at end-century bracket that trajectory — but this
 * app shows the pathways as published rather than relabelling them, because
 * mapping one onto the other is an interpretation, not a conversion.
 */
export const MODEL = "ALADIN-Climat (CNRM), indices published 2015";
export const REFERENCE_PERIOD = "1976–2005";

/**
 * The grid spacing, in metres. About 190 land cells cover Île-de-France.
 *
 * Repeated in the UI wherever a projected number appears next to a
 * parcel-level one, because rendering both at the same visual weight is the
 * single easiest way to mislead someone with this data.
 */
export const GRID_RESOLUTION_M = 8000;

/** The urban heat island layer. Far finer, and not a projection at all. */
export const ICU_SOURCE = "Institut Paris Region, IMU/LCZ classification (2022 reference)";

/**
 * Île-de-France's exposure to the sea, stated once so the panel can explain
 * rather than just omit.
 *
 * These are the two things the region genuinely has no exposure to, and saying
 * why is more useful than a section that silently is not there.
 */
export const COAST_DISTANCE_KM = 150;
export const MIN_ELEVATION_M = 11;
